import { render, staticRenderFns } from "./AddVideoResource.vue?vue&type=template&id=9eb6f40e&scoped=true"
import script from "./AddVideoResource.vue?vue&type=script&lang=js"
export * from "./AddVideoResource.vue?vue&type=script&lang=js"
import style0 from "./AddVideoResource.vue?vue&type=style&index=0&id=9eb6f40e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9eb6f40e",
  null
  
)

export default component.exports